import { render, staticRenderFns } from "./GCSLicense.vue?vue&type=template&id=25dc40c5&scoped=true&"
import script from "./GCSLicense.vue?vue&type=script&lang=ts&"
export * from "./GCSLicense.vue?vue&type=script&lang=ts&"
import style0 from "./GCSLicense.vue?vue&type=style&index=0&id=25dc40c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc40c5",
  null
  
)

export default component.exports